import { createContext, useState, useEffect, useContext, useCallback } from "react"
import { userApi } from "@/http/apiList"

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [authStatus, setAuthStatus] = useState("loading")

  const refreshAuthStatus = useCallback(async () => {
    setAuthStatus("loading")
    try {
      // API 只返回状态，我们只设置状态
      const data = await userApi.checkLoginStatus()
      if (data === 200) {
        setAuthStatus('authenticated')
      } else {
        setAuthStatus("unauthenticated")
      }
    } catch (error) {
      // 排除掉取消的请求导致的未认证状态
      if (error.message === 'canceled') {
        setAuthStatus("loading")
        return;
      }
      setAuthStatus("unauthenticated")
    }
  }, [])

  useEffect(() => {
    refreshAuthStatus()
  }, [refreshAuthStatus])

  // 暴露的值里不再有 user
  const value = {
    authStatus,
    isLoading: authStatus === "loading",
    refreshAuthStatus,
  }

  // 这里的加载逻辑依然有效
  if (authStatus === "loading") {
    return <div>App is loading...</div>
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
